module.exports = __webpack_public_path__ + "media/images/logos/good_morning_america-b6be9114732c84cf9203c2e2e811d05b.svg";